<template>
    <div class="row">
        <div class="col-md-12">
            <h4>Set up Google Authenticator</h4>
                <h5>Step 1</h5>
                <p>Scan the barcode below or enter <span class="font-weight-bold">{{ secret }}</span> into your Authenticator App.</p>
                <img :src="image">
                <h5>Step 2</h5>
                <p>Enter the authorisation code from Authenticator App</p>
                <input placeholder="Enter Code" class="form-control" v-model="token"/>
            <div class="mt-6">
                <a href="/account/security" class="mr-2">Cancel</a>
                <button class="btn btn-success" :disabled="!token" @click.prevent="verifyCode()" :class="[!token ? 'btn-light' : 'btn-success']">Complete Setup</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: ['image', 'secret'],
    data() {
        return {
           token: '',
           loading: false
        }
    },
    methods:{
        verifyCode(){
            this.loading = true;
            let data = {
                token: this.token,
                google2fa_secret: this.secret
            }

            this.authenticatorSetup(data)
                .then((response) => {
                    if(response.status === 200){
                        this.$swal({
                            type:'success',
                            title: 'Authenticator Setup Updated',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    }
                    this.loading = false;
                    window.location = '/account/security';
                })
                .catch((error) => {
                    this.loading = false;
                    this.$swal({
                        type:'error',
                        title: 'There was a problem completing Authenticator Setup',
                        showConfirmButton: false,
                        timer: 5000
                    });
                });
        }
    },
}
</script>
<style>
</style>
